import { render, staticRenderFns } from "./StatsRdvsRow.vue?vue&type=template&id=259a2704&scoped=true&"
import script from "./StatsRdvsRow.vue?vue&type=script&lang=js&"
export * from "./StatsRdvsRow.vue?vue&type=script&lang=js&"
import style0 from "./StatsRdvsRow.vue?vue&type=style&index=0&id=259a2704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259a2704",
  null
  
)

export default component.exports